<script setup lang="ts">
import type { StepAnswer } from '../types/general';

const props = defineProps<{
  question: string;
  stepAnswers: StepAnswer[];
}>();

const emit = defineEmits(['answer-selected']);
</script>

<template>
  <div class="step-answer">
    <h3>{{ props.question }}</h3>
    <div class="step-answer__answers">
      <button
        v-for="item in props.stepAnswers"
        :key="item.text"
        @click="() => emit('answer-selected', item)"
        class="btn"
        type="button"
        v-html="item.text"
      ></button>
    </div>
  </div>
</template>

<style></style>
